module.exports = __webpack_public_path__ + "img/yjscz.d11f40b2.png";